/**
 * 渡された数字にカンマを入れて返す。
 * @param {Number} x
 */
export const setCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 文字を検索用にノーマライズし配列で返す
 * @param {String} text
 * @return {String[]}
 */
export const normalizeSearchQueries = text => text.trim()
  .replace( // 全角→半角
    /[Ａ-Ｚａ-ｚ０-９]/g,
    s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
  .toLowerCase()
  .replaceAll('　', ' ')
  .split(' ')

/**
 * @param {object} pool target object
 * @param {String[]} props target properties
 * @param {String} query query for searching
 * @return {Boolean}
 */
export const matchAll = (pool, props, query) =>
  props.some(field => pool[field]
    ?.replace( // 全角→半角
    /[Ａ-Ｚａ-ｚ０-９]/g,
    s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
    .toLowerCase().includes(query))

export const isManager = (roleId) => roleId === 2 || roleId === 4
